























































import ChooseProductPanelProduct
  from '@/components/ui/popups/promotions/PromotionViewPopup/components/ChooseProductPanelProduct.vue';
import BuyXGetY from '@/models/buyXGetY';
import BuyXGetYProduct from '@/models/buyXGetYProduct';
import { directive as onClickaway } from 'vue-clickaway';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ReceivedProductsPanel',
  components: {ChooseProductPanelProduct},
  directives: {
    onClickaway: onClickaway,
  },
})
export default class ReceivedProductsPanel extends Vue {
  @Prop({
    type: BuyXGetY,
    required: true,
  })
  private promotion!: BuyXGetY;

  private getImage(product: BuyXGetYProduct) {
    if (product.image) {
      return this.$generateAssetsUrl(product.image);
    }

    return '../../../../../../assets/images/product-placeholder.png';
  }

  private mounted() {
    document.body.appendChild(<HTMLElement> this.$el);
  }

  private beforeDestroy() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }

  private close() {
    this.$emit('close');
  }
}
